var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfficesAndStates(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 385.706,
    height: 91.389,
    viewBox: "0 0 385.706 91.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.214,
    y1: -2.169,
    x2: 32.036,
    y2: -2.136,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.22,
    y1: 0.147,
    x2: 0.909,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.73,
    cy: 0.243,
    r: 0.793,
    gradientTransform: "matrix(-1, 0, 0, 1, 1.459, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd77d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#ffd466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffd363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffd05a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffca4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#ffc335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffb919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.76,
    cy: 0.582,
    r: 0.623,
    gradientTransform: "matrix(-0.708, -0.707, -0.381, 0.38, 50.684, -17.638)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Pinned",
    transform: "translate(-127.162 -719.151)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bar",
    d: "M129-226.25H514.706v-4H129Z",
    transform: "translate(-1.838 1036.79)",
    fill: "url(#linear-gradient-300)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy",
    transform: "translate(-31.965 1047)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "states",
    transform: "translate(454.833 -258.996)",
    fill: "#7b8b8d",
    fontSize: 30,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "states")), /*#__PURE__*/React.createElement("text", {
    id: "_11",
    "data-name": 11,
    transform: "translate(403.833 -258.46)",
    fill: "#52d2f6",
    fontSize: 48,
    fontFamily: "GothamBold, Gotham Bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("text", {
    id: "offices",
    transform: "translate(287.497 -258.996)",
    fill: "#7b8b8d",
    fontSize: 30,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "offices")), /*#__PURE__*/React.createElement("text", {
    id: "_27",
    "data-name": 27,
    transform: "translate(217.497 -258.46)",
    fill: "#52d2f6",
    fontSize: 48,
    fontFamily: "GothamBold, Gotham Bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "27")))), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(119.622 719.151)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2794",
    "data-name": "Group 2794",
    transform: "translate(4 60.434)",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M39,66.59c0-3.68-8.58-6.67-19.16-6.67S.63,62.91.63,66.59s8.58,6.67,19.16,6.67S39,70.27,39,66.59Z",
    transform: "translate(2.91 -59.17)",
    fill: "#e2e2e2",
    opacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M37.75,66.6c0-3.55-8.26-6.42-18.46-6.42S.84,63.05.84,66.6,9.1,73,19.29,73,37.75,70.14,37.75,66.6Z",
    transform: "translate(3.95 -59.17)",
    fill: "#d8d8d8",
    opacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M36.55,66.6c0-3.41-7.94-6.17-17.75-6.17S1.05,63.19,1.05,66.6,9,72.77,18.8,72.77,36.55,70,36.55,66.6Z",
    transform: "translate(4.94 -59.17)",
    fill: "#cecece",
    opacity: 0.19
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M35.26,66.61c0-3.28-7.63-5.93-17-5.93s-17,2.65-17,5.93,7.63,5.92,17,5.92S35.26,69.88,35.26,66.61Z",
    transform: "translate(6.02 -59.17)",
    fill: "#c4c4c4",
    opacity: 0.23
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M34.15,66.61c0-3.13-7.31-5.67-16.34-5.67S1.47,63.48,1.47,66.61s7.31,5.68,16.34,5.68S34.15,69.75,34.15,66.61Z",
    transform: "translate(6.92 -59.17)",
    fill: "#bababa",
    opacity: 0.27
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M33,66.62c0-3-7-5.43-15.64-5.43S1.68,63.62,1.68,66.62s7,5.43,15.64,5.43S33,69.62,33,66.62Z",
    transform: "translate(7.86 -59.17)",
    fill: "#b1b1b1",
    opacity: 0.31
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M31.76,66.62c0-2.86-6.69-5.18-14.94-5.18S1.88,63.76,1.88,66.62,8.57,71.8,16.82,71.8,31.76,69.49,31.76,66.62Z",
    transform: "translate(8.9 -59.17)",
    fill: "#a7a7a7",
    opacity: 0.35
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M30.56,66.63c0-2.73-6.38-4.94-14.24-4.94S2.09,63.9,2.09,66.63s6.37,4.93,14.23,4.93S30.56,69.35,30.56,66.63Z",
    transform: "translate(9.89 -59.17)",
    fill: "#9d9d9d",
    opacity: 0.38
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M29.36,66.63C29.36,64,23.3,62,15.82,62S2.3,64,2.3,66.63s6.06,4.69,13.52,4.69S29.36,69.22,29.36,66.63Z",
    transform: "translate(10.88 -59.17)",
    fill: "#939393",
    opacity: 0.42
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M28.16,66.64c0-2.45-5.74-4.44-12.83-4.44s-12.82,2-12.82,4.44,5.74,4.44,12.82,4.44S28.16,69.09,28.16,66.64Z",
    transform: "translate(11.87 -59.17)",
    fill: "#898989",
    opacity: 0.46
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M27,66.65c0-2.32-5.43-4.2-12.13-4.2S2.72,64.33,2.72,66.65s5.43,4.19,12.12,4.19S27,69,27,66.65Z",
    transform: "translate(12.82 -59.17)",
    fill: "gray",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M25.77,66.65c0-2.18-5.11-3.94-11.42-3.94S2.93,64.47,2.93,66.65s5.11,3.94,11.42,3.94S25.77,68.83,25.77,66.65Z",
    transform: "translate(13.84 -59.17)",
    fill: "#767676",
    opacity: 0.54
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M24.57,66.66c0-2-4.8-3.7-10.72-3.7S3.14,64.61,3.14,66.66s4.8,3.69,10.71,3.69S24.57,68.7,24.57,66.66Z",
    transform: "translate(14.83 -59.17)",
    fill: "#6c6c6c",
    opacity: 0.58
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M23.35,66.66c0-1.9-4.48-3.45-10-3.45s-10,1.55-10,3.45,4.48,3.45,10,3.45S23.35,68.57,23.35,66.66Z",
    transform: "translate(15.84 -59.17)",
    fill: "#626262",
    opacity: 0.62
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M22.17,66.67c0-1.77-4.17-3.21-9.31-3.21s-9.3,1.44-9.3,3.21,4.16,3.2,9.3,3.2S22.17,68.44,22.17,66.67Z",
    transform: "translate(16.81 -59.17)",
    fill: "#585858",
    opacity: 0.65
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M21,66.67c0-1.63-3.85-3-8.6-3s-8.63,1.33-8.63,3,3.86,3,8.61,3S21,68.3,21,66.67Z",
    transform: "translate(17.77 -59.17)",
    fill: "#4e4e4e",
    opacity: 0.69
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M19.78,66.68c0-1.5-3.51-2.68-7.88-2.68S4,65.21,4,66.71s3.54,2.71,7.9,2.71S19.78,68.17,19.78,66.68Z",
    transform: "translate(18.76 -59.17)",
    fill: "#454545",
    opacity: 0.73
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M18.58,66.68c0-1.36-3.22-2.46-7.2-2.46s-7.19,1.1-7.19,2.46,3.22,2.46,7.19,2.46S18.58,68,18.58,66.68Z",
    transform: "translate(19.77 -59.17)",
    fill: "#3b3b3b",
    opacity: 0.77
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M17.38,66.69c0-1.22-2.9-2.21-6.49-2.21s-6.49,1-6.49,2.21,2.9,2.21,6.49,2.21S17.38,67.91,17.38,66.69Z",
    transform: "translate(20.76 -59.17)",
    fill: "#313131",
    opacity: 0.81
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M16.19,66.69c0-1.08-2.59-2-5.79-2s-5.79.88-5.79,2,2.6,2,5.79,2S16.19,67.78,16.19,66.69Z",
    transform: "translate(21.74 -59.17)",
    fill: "#272727",
    opacity: 0.85
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M15,66.7c0-1-2.27-1.72-5.08-1.72s-5.1.77-5.1,1.72,2.28,1.72,5.09,1.72S15,67.65,15,66.7Z",
    transform: "translate(22.72 -59.17)",
    fill: "#1d1d1d",
    opacity: 0.88
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M13.76,66.7c0-.81-2-1.47-4.38-1.47S5,65.89,5,66.7s2,1.48,4.38,1.48S13.76,67.52,13.76,66.7Z",
    transform: "translate(23.78 -59.17)",
    fill: "#141414",
    opacity: 0.92
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M12.59,66.71c0-.67-1.64-1.22-3.67-1.22s-3.68.55-3.68,1.22,1.65,1.22,3.68,1.22S12.59,67.39,12.59,66.71Z",
    transform: "translate(24.71 -59.17)",
    fill: "#0a0a0a",
    opacity: 0.96
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M11.45,66.72c0-.54-1.32-1-3-1s-3,.44-3,1,1.33,1,3,1S11.45,67.25,11.45,66.72Z",
    transform: "translate(25.64 -59.17)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M16.96,66.08,2.8,13.21l3.45-.93L20.44,65.44l.2.56a2.37,2.37,0,0,1-.06.52,1.82,1.82,0,0,1-2.24,1.24,1.86,1.86,0,0,1-1.18-1v-.14Z",
    transform: "translate(19.1 0.02)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M16.96,66.08,2.8,13.21l3.45-.93L20.44,65.44l.2.56a2.37,2.37,0,0,1-.06.52,1.82,1.82,0,0,1-2.24,1.24,1.86,1.86,0,0,1-1.18-1v-.14Z",
    transform: "translate(19.1 0.02)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M16.96,66.08,2.8,13.21l3.45-.93L20.44,65.44l.2.56a2.37,2.37,0,0,1-.06.52,1.82,1.82,0,0,1-2.24,1.24,1.86,1.86,0,0,1-1.18-1v-.14Z",
    transform: "translate(19.1 0.02)",
    opacity: 0.5,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "darken",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M2.36,15.92A15.94,15.94,0,1,1,18.29,31.86,15.94,15.94,0,0,1,2.36,15.92Z",
    transform: "translate(5.94 0.02)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M4.665,1.55c-1.9,1.89-.59,6.27,2.91,9.77s7.89,4.82,9.78,2.92.59-6.24-2.92-9.78S6.555-.35,4.665,1.55Z",
    transform: "translate(20.525 0.02)",
    opacity: 0.6,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficesAndStates);
export default __webpack_public_path__ + "static/media/OfficesAndStates.669d51fd26610b206236aa44db5cf7de.svg";
export { ForwardRef as ReactComponent };